export type GameOnboardingPopupId =
  | 'challenge_intro'
  | 'challenge_completed'
  | 'prize_box_opened'
  | 'prize_unlocked';

/** Preferred Firestore doc ids under Global_lookup/onboarding/game_new/. */
export const GAME_ONBOARDING_POPUP_DOC: Record<GameOnboardingPopupId, string> = {
  challenge_intro: 'challenge_intro',
  challenge_completed: 'challenge_completed',
  prize_box_opened: 'prize_box_opened',
  prize_unlocked: 'prize_unlocked',
};

/**
 * Rollout fallbacks: try preferred FE ids first, then legacy CMS/backend ids
 * so content still loads if documents have not been renamed yet.
 */
export const GAME_ONBOARDING_POPUP_DOC_CANDIDATES: Record<
  GameOnboardingPopupId,
  readonly string[]
> = {
  challenge_intro: ['challenge_intro', 'challenge_initial_popup'],
  challenge_completed: ['challenge_completed', 'challenge_popup'],
  prize_box_opened: ['prize_box_opened', 'prizebox_popup'],
  prize_unlocked: ['prize_unlocked', 'prizeunlocker_popup'],
};

export interface GameOnboardingPopupContent {
  title: string;
  prize_label: string;
  prize_value: string;
  line_1: string;
  line_2: string;
  line_3?: string;
  cta_text: string;
}

export interface GameOnboardingPopupDoc {
  type: string;
  active: boolean;
  background: string;
  banner_background: string;
  banner_text_color: string;
  panel_color: string;
  text_color: string;
  header_icon_background: string;
  /** Optional CTA styling from Global_lookup/onboarding/game_new docs. */
  cta_background?: string;
  cta_text_color?: string;
  cta_shadow_color?: string;
  images: Record<string, string | undefined>;
  content: Record<string, GameOnboardingPopupContent | undefined>;
  cta?: unknown;
}

export interface OnboardingPopupDialogData {
  popupId: GameOnboardingPopupId;
  docId: string;
  preloaded?: GameOnboardingPopupDoc;
}

export type OnboardingPopupCloseReason = 'cta' | 'dismiss' | 'inactive' | 'unknown';
